import { Grid, Typography } from '@mui/material';
import { useForm } from "react-hook-form";
import { ControlledInput } from '../../components/forms/input/ControlledInput';
import { endpoints } from '../../api/endpoints';
import { ModalFooter } from '../../components/modal/ModalFooter';
import AddEditModal from '../../components/modal/Modal';
import { toast } from 'react-toastify';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from "yup";


export default function AddEditVendorModal({ refetchData, setIsView, isView, open, setOpen, setSelectedItem, selectedItem }: { refetchData?: any, setIsView?: any, isView?: boolean, open: boolean, setOpen: (value: boolean) => void, selectedItem: any, setSelectedItem: (value: any) => void }) {

    return (
        <AddEditModal isView={isView} setIsView={setIsView} title={isView ? 'View Vendor' : selectedItem ? 'Edit Vendor' : 'Add New Vendor'} setOpen={setOpen} setSelectedItem={setSelectedItem} open={open}>
            <GeneralInfo refetchData={refetchData} setIsView={setIsView} isView={isView} selectedItem={selectedItem} setSelectedItem={setSelectedItem} setOpen={setOpen} />
        </AddEditModal>
    );
}

const GeneralInfo = ({ setIsView, isView, setSelectedItem, selectedItem, setOpen, refetchData }: { refetchData?: any, setIsView?: any, isView?: boolean, setSelectedItem: (value: any) => void, selectedItem: any, setOpen: (value: boolean) => void }) => {
    const { handleSubmit, control, formState: { errors, } } = useForm(
        {
            resolver: yupResolver(VendorSchema),
            defaultValues: selectedItem ?? {
                vendorName: '',
            }
        }
    )

    const cancelMessage = 'Cancel current unsaved changes and go back to locker vendor list?'

    const onSuccess = (values: any, id?: number) => {
        if (values.id) {
            setOpen(false);
            setSelectedItem(null)
            setIsView(false)
            refetchData()
        } else {
            refetchData()
            setOpen(false);
            setSelectedItem(null)
            setIsView(false)
        }
    }

    const onError = (err: any) => {
        toast.error(err)
        setOpen(false);
        setSelectedItem(null)
        setIsView(false)
    }

    const handleClose = () => {
        setOpen(false);
        setSelectedItem(null)
        setIsView(false)
    };



    return (
        <>
            <Typography component={'p'} mt={2} mb={2}>General Information</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} >
                    <ControlledInput name="vendorName" control={control} errors={errors} label="Name" disabled={isView} />
                </Grid>
            </Grid>
            {isView ? null : <ModalFooter endpoint={endpoints.lockerVendor.post} onSuccess={onSuccess} handleSubmit={handleSubmit} handleModalClose={handleClose} selectedItem={selectedItem} cancelMessage={cancelMessage} onError={onError} />}
        </>
    )
}


export const VendorSchema = Yup.object().shape({
    vendorName: Yup.string().required("Name is required"),
});